/* Ruby's Tamales — Theme JS v2 */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile Menu ──
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const drawer = document.querySelector('.mobile-drawer');
  const drawerClose = document.querySelector('.drawer-close');
  const drawerOverlay = document.querySelector('.mobile-drawer__overlay');

  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', () => {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
    const closeDrawer = () => {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  // ── Product Detail Accordions ──
  document.querySelectorAll('.detail-row').forEach(row => {
    row.addEventListener('click', function () {
      const isOpen = this.classList.contains('open');
      document.querySelectorAll('.detail-row').forEach(r => r.classList.remove('open'));
      if (!isOpen) this.classList.add('open');
    });
  });

  // ── FAQ Accordion ──
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) {
        item.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      } else {
        this.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // ── Quantity Buttons ──
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const row = this.closest('.qty-row') || this.closest('.product-page__qty');
      if (!row) return;
      const input = row.querySelector('.qty-input');
      const current = parseInt(input.value) || 1;
      input.value = this.dataset.action === 'minus' ? Math.max(1, current - 1) : current + 1;
    });
  });

  // ── Variant Pills (product cards) ──
  document.querySelectorAll('.product-card__variants').forEach(group => {
    group.querySelectorAll('.variant-pill').forEach(pill => {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });

  // ── Variant Buttons (product page) ──
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const variantInput = document.getElementById('variantId');
      if (variantInput) variantInput.value = this.dataset.variantId;
    });
  });

  // ── Salsa Thumbnail Switcher ──
  document.querySelectorAll('.variant-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.variant-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ── Cart qty auto-update ──
  document.querySelectorAll('.cart-qty-input').forEach(input => {
    input.addEventListener('change', function () {
      const form = this.closest('form');
      if (form) form.submit();
    });
  });

  // ── Waitlist form ──
  const waitlistForm = document.querySelector('.waitlist-form');
  if (waitlistForm) {
    const btn = waitlistForm.querySelector('.waitlist-submit');
    const input = waitlistForm.querySelector('.waitlist-input');
    if (btn && input) {
      btn.addEventListener('click', function () {
        const val = input.value.trim();
        if (!val) { input.focus(); return; }
        btn.textContent = '✓ You\'re on the list';
        btn.style.background = 'var(--masa)';
        input.value = '';
        input.disabled = true;
        btn.disabled = true;
      });
    }
  }

  // ── Smooth scroll ──
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Scroll-triggered fade for story/salsa sections ──
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.info-card, .how-step, .faq-item').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

});
document.querySelectorAll('.faq-question').forEach(function(btn) {
  btn.onclick = function() {
    var item = this.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };
});